module.exports = __webpack_public_path__ + "static/img/empty-shop-follow.003abb3c.png";